module.exports = __webpack_public_path__ + "img/matching.a0a0f619.png";